import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin-bottom: ${rem(40)};
`;

export const Title = styled.span<{ withoutBackground?: boolean }>`
    display: block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    background: ${(prop) => (prop.withoutBackground ? prop.theme.colors.white : prop.theme.colors.darkLight)};
    padding: ${rem(15)} 0 ${rem(35)} 0;
    border-top-left-radius: ${rem(8)};
    border-top-right-radius: ${rem(8)};
`;

export const SubTitle = styled.h3`
    font-size: ${({ theme }) => theme.fontSizes.h5};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding-bottom: ${rem(15)};
    display: block;
`;

export const Lecturer = styled.div<{ withBackground?: boolean }>`
    padding: ${rem(25)} 0;
    display: flex;
    flex-direction: column;
    ${(prop) => (prop.withBackground ? `background: ${prop.theme.colors.darkLight};` : '')};
    border-bottom-left-radius: ${rem(8)};
    border-bottom-right-radius: ${rem(8)};

    @media (min-width: ${breakpoints.sm}px) {
        flex-direction: row;
    }
`;

export const Information = styled.div`
    padding-top: ${rem(25)};

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0 ${rem(25)};
    }
`;

export const Position = styled.p`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
`;

export const Mail = styled.a`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    display: block;
    margin-top: ${rem(10)};
`;

export const Description = styled.p`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    line-height: ${rem(30)};
    color: ${({ theme }) => theme.colors.grey};
`;

export const ImageSection = styled.div``;

export const Image = styled.img`
    width: ${rem(120)};
    height: auto;
`;

export const Name = styled.span`
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h5};
`;

export const Events = styled.div<{ withoutBorder?: boolean }>`
    padding: ${rem(35)} 0;
    border-bottom: 1px solid ${(prop) => (prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey)};
`;

export const Event = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    cursor: pointer;
    margin-bottom: ${rem(8)};
`;

export const EventDate = styled.div`
    padding-top: ${rem(5)};
    padding-right: ${rem(30)};
    width: ${rem(250)};
`;

export const EventName = styled.button`
    color: ${({ theme }) => theme.colors.primary};
    background: none;
    padding: ${rem(5)} 0 0 0;
    cursor: pointer;
    border: 0;
    text-align: left;
    margin-bottom: ${rem(5)};
    -webkit-box-flex: 0;
    flex: 0 0 66.666667%;
    max-width: 66.666667%;
    @media (max-width: ${breakpoints.sm}px) {
        flex: 0 0 100%;
        max-width: 100%;
    }
`;

export const Archives = styled.div<{ withoutBorder?: boolean }>`
    padding: ${rem(35)} ${rem(25)};
    border-bottom: 1px solid ${(prop) => (prop.withoutBorder ? prop.theme.colors.white : prop.theme.colors.secondaryGrey)};
    display: flex;
    flex-direction: column;
`;

export const ArchiveName = styled.button`
    color: ${({ theme }) => theme.colors.primary};
    background: none;
    padding: ${rem(5)} 0 0 0;
    text-align: left;
    cursor: pointer;
    border: 0;
`;

export const MoreLink = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    text-align: left;
    margin-top: ${rem(30)};
    display: flex;
    flex-direction: row;
    text-decoration: underline;

    svg {
        width: ${rem(14)};
        height: ${rem(10)};
        transform: rotate(-90deg);
    }
`;
